import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';
import RouterCardView from '~/src/features/full-buy/containers/EquipmentList/RouterCardsView';
import { getIsDisabledByLimits, getLimits } from '~/src/features/full-buy/helpersForProducts';
import { selectProductsByCategory } from '~/src/features/full-buy/store/selectors/products/selectProductsByCategory';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';
import { TState } from '~/src/store';

interface IProps {
    openAddEquipmentPopup: (equipment: TProduct, isInstallmentDisabled: boolean) => () => void,
    handleDecrement: (id: number) => () => void,
    handleIncrement: (id: number) => () => void,
    category?: EShopCategory.Routers | EShopCategory.PrivateSectorEquipment,
}

export const RouterCardsViewWithCarousel = ({
    category = EShopCategory.Routers,
    handleIncrement,
    handleDecrement,
    openAddEquipmentPopup,
}: IProps) => {
    const equipments = useSelector((state: TState) => selectProductsByCategory(state, category));

    const limits = useMemo(() => getLimits(equipments, category), [equipments, category]);

    return <>
        <FullWidthListContainer $desktop={16} $mobile={12} $direction={'row'} $wrap={'wrap'}>
            <AdaptiveNukaCarousel
                withoutDots
                cellSpacing={16}
                slidesToScroll={'auto'}
                desktopSlideWidth={'304px'}
                mobileSlideWidth={'164px'}
                data-test='routers-carousel'
            >
            {equipments.map((product) => {
                const { selectedPrice } = product;

                const isDisabled = getIsDisabledByLimits({
                    limits,
                    duration: selectedPrice.duration,
                    productQuantity: product.quantity,
                });

                return (
                    <RouterCardView
                        key={`RouterEntity_${product.id}`}
                        openAddEquipmentPopup={openAddEquipmentPopup}
                        handleIncrement={handleIncrement}
                        handleDecrement={handleDecrement}
                        isDisabled={isDisabled}
                        product={product}
                        isSkipImages={true}
                    />
                );
            })}
            </AdaptiveNukaCarousel>
        </FullWidthListContainer>
    </>;
};
